import { useMemo } from "react";

import { mergeProps } from "@ui/utils/merge-props";

/**
 * Provide nested defaults for props while preserving
 * object identities (objects, arrays, functions, etc) to
 * ensure that shallow comparing props continue to work.
 */
export default function useDefaults<
  P extends Record<string, any>,
  D extends Record<string, any>,
>(props: P, defaults: D): P & D {
  return useMemo(
    () => mergeProps(defaults, props),
    // eslint-disable-next-line react-hooks/exhaustive-deps, @typescript-eslint/no-unsafe-assignment
    [...Object.values(props), ...Object.values(defaults)],
  );
}
